import React from "react";
import CategoriesIndex from "../Catalogo/CategoriesIndex";
import Layout from "../../components/Layout/Layout";
import { Banner } from "../../components/Layout/Banner";
import { Info } from "../Catalogo/Info";
import LaunchesBanner from "../Catalogo/LaunchesBanner";
import SEO from "../../components/SEO/SEO";

const Index = () => {
  //Esta es la pagina principal de la tienda autenticado
  return (
    <>
      <SEO
        title="Inicio"
        image="/merry.png"
      />
      <Layout>
        <Banner />
        <LaunchesBanner />
        <CategoriesIndex />
        <Info />
      </Layout>
    </>
  );
};

export default Index;
